const typographyTimeActions = {
  timelineTitle: 'Timeline',
  adminWarning: 'Administradores podem editar as informações, adicionar arquivos, comentários e concluir/cancelar ações',
  analystWarning: 'Analistas podem adicionar arquivos, comentários e concluir/cancelar qualquer ação, e editar as informações das ações que criaram',
  contractorWarning: 'Contratadas podem adicionar arquivos, comentários e concluir/cancelar as ações que são responsáveis',
};

export default typographyTimeActions;
